import React from 'react'
import useAxios from 'axios-hooks'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import StatusCard from '~/components/StatusCards'

import {
  SearchParamsHandlerProvider,
  useSearchParamsHandler,
} from '~/contexts/FilterContext'
import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params'
import Styles from './styles'
import HeaderMenu from './components/Header'
import { CLIENT } from '~/constants/roles'
import Pagination from '~/components/Pagination'
import { FormattedMessage } from 'react-intl'

import { ReactComponent as ListIcon } from '../../../../assets/img/svg/list-bullets.svg'
import { ReactComponent as GridIcon } from '../../../../assets/img/svg/grid.svg'
import FilterButton from '~/components/FilterButton'
import DefaultFilterHandler from '~/components/Filters/Default/Handler'
import { getDefaultFiltersCount } from '~/helpers/getFilterCount'
import GridView from './components/GridView'
import { sizes } from '~/constants/mediaQuery'
import SearchInput from '~/components/SearchInput'
import ListView from './components/ListView'

function LocationsOverviewInner() {
  const [filterOn, setFilterOn] = React.useState(false)
  const currentProjectId = useSelector(state => state.user?.selectedProject?.id)
  const {
    query: { allLocations, view, ...query },
    setQuery,
  } = useSearchParamsHandler()
  const [{ data, loading }] = useAxios({
    url: `/locations`,
    method: 'GET',
    params: {
      project: allLocations ? undefined : currentProjectId,
      ...query,
    },
  })

  const setView = str => {
    setQuery('view', str)
  }

  const userProfile = useSelector(state => state.user?.profile)
  const userIsClient = userProfile?.role === CLIENT

  const totalItems = data?.metadata?.total || 0
  const totalPages = Math.ceil((data?.metadata?.total || 0) / query.limit)
  const { states, cities, areas, labels, locations } = query
  const filterCount = getDefaultFiltersCount({
    states,
    cities,
    areas,
    labels,
    locations,
  })
  const isMobile = window.innerWidth < +sizes.sm.replace('px', '')
  return (
    <Styles.MyLocationsWrapper>
      <BreadcrumbHeader path={[{ name: 'Locations', path: 'locations' }]}>
        <HeaderMenu />
      </BreadcrumbHeader>

      <StatusCard
        total={data?.metadata?.total}
        open={data?.metadata?.open}
        closed={data?.metadata?.closed}
        tempClosed={data?.metadata?.temp}
      />
      <Styles.LocationsDiv>
        <Styles.PageMenu>
          <h2>
            <FormattedMessage id={'Locations'} />
          </h2>
          <Styles.LocationMenu>
            {!isMobile && (
              <>
                <SearchInput />
                <button
                  className="view-button"
                  data-active={view === 'LIST'}
                  onClick={() => setView('LIST')}
                >
                  <ListIcon />
                </button>
                <button
                  className="view-button"
                  data-active={view === 'GRID'}
                  onClick={() => setView('GRID')}
                >
                  <GridIcon />
                </button>
              </>
            )}

            <FilterButton
              filterCount={filterCount}
              isActive={filterOn}
              onClick={() => setFilterOn(prevState => !prevState)}
            />
          </Styles.LocationMenu>
        </Styles.PageMenu>
        {isMobile && (
          <div style={{ padding: '8px 0' }}>
            <SearchInput />
          </div>
        )}
        <DefaultFilterHandler
          open={filterOn}
          onClose={() => setFilterOn(false)}
        />
        {Boolean(
          states.concat(cities, areas, labels, locations).slice(0, 9).length
        ) && (
          <Styles.FilterTagsDiv>
            {states
              .concat(cities, areas, labels, locations)
              .slice(0, 9)
              .map((item, index) => {
                return <div key={`tag-${index}`}>{item}</div>
              })}
            {states.concat(cities, areas, labels, locations).length > 9 && (
              <div>
                +{states.concat(cities, areas, labels, locations).length - 9}
              </div>
            )}
          </Styles.FilterTagsDiv>
        )}

        {(view === 'GRID' || isMobile) && (
          <GridView
            loading={loading}
            locations={data?.locations}
            userIsClient={userIsClient}
          />
        )}

        {view === 'LIST' && !isMobile && (
          <ListView locations={data?.locations} userIsClient={userIsClient} />
        )}

        <Pagination totalItems={totalItems} totalPages={totalPages}>
          <Pagination.Limit />
          <Pagination.Pages />
        </Pagination>
      </Styles.LocationsDiv>
    </Styles.MyLocationsWrapper>
  )
}

const LocationsOverview = () => {
  const arrayParam = withDefault(
    {
      encode: array => array,
      decode: array => array?.split(','),
    },
    []
  )

  return (
    <SearchParamsHandlerProvider
      queryParams={{
        states: withDefault(arrayParam, []),
        cities: withDefault(arrayParam, []),
        areas: withDefault(arrayParam, []),
        labels: withDefault(arrayParam, []),
        locations: withDefault(arrayParam, []),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 10),
        sort: withDefault(StringParam, ''),
        sortBy: withDefault(StringParam, ''),
        allLocations: withDefault(BooleanParam, true),
        view: withDefault(StringParam, 'LIST'),
        search: StringParam,
      }}
    >
      <LocationsOverviewInner />
    </SearchParamsHandlerProvider>
  )
}

export default LocationsOverview
